<template>
  <div id="app">
    <Header></Header>
    <div class="main-container">
      <img class="header-bg" src="../assets/img/banner5.jpg" alt="" />

      <div class="crop-selector-container" style="display:none;">
        <div v-for="cropType in cropList" :key="cropType.articleAreaId">
          <div
            class="crop-selector"
            v-if="!!cropType.children && cropType.children.length > 0"
          >
            <div class="crop-item">
              <div class="crop-group">{{ cropType.areaName }}</div>
              <div class="crop-titles">
                <a
                  @click="toggleType(crop.articleAreaId)"
                  :class="{ active: crop.articleAreaId == id }"
                  v-for="crop in cropType.children"
                  :key="crop.articleAreaId"
                  >{{ crop.areaName }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="articleList-container">
        <div class="articleList-content">
          <div class="articleList">
            <Card :list="cardList" :type="cardType"></Card>
            <div
              style="
                margin: 24px 0 40px;
                display: flex;
                justify-content: center;
              "
            >
              <Pagination
                :totalpage="totalpage"
                @pageChange="pageChange"
              ></Pagination>
            </div>
          </div>

          <!-- <div class="likeList">
            <Like :list="cardList"></Like>
          </div> -->
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import Pagination from "../components/pagination.vue";
import Card from "../components/cardList.vue";
// import Like from "../components/likeList.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    Pagination,
    Card,
    // Like,
  },
  data: () => {
    return {
      totalpage: 100,
      currentpage: 1,

      cardType: "0", //0 农技文章
      cardList: [
        {
          title: "",
          desc: "",
          author: "",
          time: "",
          clickViews: 10,
          imgUrl: "",
        },
      ],
      id: "",
      cropList: [],
    };
  },
  beforeMount() {
    function getUrlString() {
      var urlStr = window.location.search; //?sex=man&age=20
      console.log(urlStr);
      if (urlStr != null && urlStr.toString().length > 1) {
        var myUrlStr = urlStr.substr(1); //sex=man&age=20
        var array1 = myUrlStr.split("&"); //["sex=man"],["age=20"]
        var getString = {};
        for (var i = 0; i < array1.length; i++) {
          getString[array1[i].split("=")[0]] = array1[i].split("=")[1]; //["sex","man"]["age","20"]
        }
        return getString;
      } else {
        console.log("无参数");
      }
    }
    var gus = new getUrlString();
    this.id = gus.cropId || '';
    console.log(gus);
    this.$axios
      .get("https://m.nongjike.cn/app/community/findWebSiteArticleArea")
      .then((data) => {
        data = data.data;
        this.cropList = data.information;
      });
    this.$axios
      .get(
        `post/findResearchList?articleAreaId=${this.id}&userId=1&pageSize=10&pageNum=1&randStatus=1&dateStatus=1`
      )
      .then((data) => {
        data = data.data;
        this.totalpage = data.information.total;
        this.cardList = data.information.list.map((v) => {
          let con = v.content;
          let msg = con.replace(/<style>[\s\S]*?<\/style>/gi, ""); //去除HTML Tag
          msg = msg.replace(/<\/?[^>]*>/g, "");
          msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
          msg = msg.replace(/&nbsp;/gi, "");

          return {
            title: `${v.subject}`,
            desc: msg.replace(/&nbsp;/g, ""),
            author: v.name,
            time: v.recoverDate,
            clickViews: v.clickViews,
            imgUrl:
              v.coverImg ||
              (v.researchImgEntities.length > 0
                ? v.researchImgEntities[0].coverImg
                : ""),
            link: `yyal.html?id=${v.researchId}`,
          };
        });
        this.loading = false;
      });
  },
  methods: {
    pageChange(n) {
      this.$axios
        .get(
          `post/findResearchList?articleAreaId=${this.id}&userId=1&pageSize=10&pageNum=${n}&randStatus=1&dateStatus=1`
        )
        .then((data) => {
          data = data.data;
          this.totalpage = data.information.total;
          this.cardList = data.information.list.map((v) => {
            let con = v.content;
            let msg = con.replace(/<style>[\s\S]*?<\/style>/gi, ""); //去除HTML Tag
            msg = msg.replace(/<\/?[^>]*>/g, "");
            msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
            msg = msg.replace(/&nbsp;/gi, "");

            return {
              title: `${v.subject}`,
              desc: msg.replace(/&nbsp;/g, ""),
              author: v.name,
              time: v.recoverDate,
              clickViews: v.clickViews,
              imgUrl:
                v.coverImg ||
                (v.researchImgEntities.length > 0
                  ? v.researchImgEntities[0].coverImg
                  : ""),
              link: `yyal.html?id=${v.researchId}`,
            };
          });
          this.loading = false;
        });
    },
    toggleType(id) {
      if (this.id == id) {
        this.id = "";
      } else {
        this.id = id;
      }

      this.loading = true;
      this.$axios
        .get(
          `post/findResearchList?articleAreaId=${this.id}&userId=1&pageSize=10&pageNum=1&randStatus=1&dateStatus=1`
        )
        .then((data) => {
          data = data.data;
          this.totalpage = data.information.total;
          this.cardList = data.information.list.map((v) => {
            let con = v.content;
            let msg = con.replace(/<style>[\s\S]*?<\/style>/gi, ""); //去除HTML Tag
            msg = msg.replace(/<\/?[^>]*>/g, "");
            msg = msg.replace(/[|]*\n/, ""); //去除行尾空格
            msg = msg.replace(/&nbsp;/gi, "");

            return {
              title: `${v.subject}`,
              desc: msg.replace(/&nbsp;/g, ""),
              author: v.name,
              time: v.recoverDate,
              clickViews: v.clickViews,
              imgUrl:
                v.coverImg ||
                (v.researchImgEntities.length > 0
                  ? v.researchImgEntities[0].coverImg
                  : ""),
              link: `yyal.html?id=${v.researchId}`,
            };
          });
          this.loading = false;
        });
    },
  },
  mounted: () => {},
};
</script>

<style lang="scss" scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 121px;
}
a {
  & > * {
    text-decoration: none;
  }
  text-decoration: none;
}

.image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  img {
    width: 50%;
    height: auto;
    display: block;
  }
}

.main-container {
  width: 100%;
  .header-bg {
    width: 100%;
    display: block;
  }
}
.crop-selector-container {
  width: 100%;
  background: #f5f5f5;
  padding: 40px 0 28px;
  .crop-selector {
    width: 1200px;
    margin: 0 auto;

    .crop-item {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: nowrap;
      margin-bottom: 18px;
      &:last-child {
        margin-bottom: 0;
      }
      .crop-group {
        font-size: 16px;
        width: 80px;
        color: #333;
        text-align: left;
        margin-right: 10px;
        line-height: 20px;
      }
      .crop-titles {
        font-size: 16px;
        width: 100px;
        flex-grow: 1;
        color: #999;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        line-height: 24px;

        a {
          border-right: 1px solid #999;
          color: #999;
          min-width: 90px;
          text-align: center;
          padding: 0 20px;
          line-height: 20px;
          height: 20px;
          cursor: pointer;
          margin-bottom: 12px;
          &:hover {
            color: #65b825;
          }
          &.active {
            color: #65b825;
          }
          &:last-child {
            border-right: none;
          }
        }
      }
    }
  }
}
.articleList-container {
  width: 100%;
  background: #fff;
  .articleList-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 30px;
    .articleList {
      width: 100px;
      flex-grow: 1;
      //   margin-right: 54px;
    }

    .likeList {
      width: 360px;
    }
  }
}
@media screen and (max-width: 1200px) {
  #app {
    margin-top: 91px;
  }
  .login_container {
		padding-left: 10px;
	}
	.headers {
		width: 100%;
		padding-left: 10px;
	}
	#app {
		overflow: hidden;
	}
	#app .headers .header-nav {
		display: none;
	}

  .crop-selector-container .crop-selector{
    width: 100%;
  }
  .crop-selector-container .crop-selector .crop-item .crop-group{
    margin-right: 0;
    font-size: 14px;
  }
  .crop-selector-container .crop-selector .crop-item .crop-titles{
    font-size: 14px;
    line-height: 20px;
    a{
      min-width: 80px;
      margin-bottom: 6px;
    }
  }
  .crop-selector-container{
    padding: 20px 10px 14px;
  }
  .likeList{
    display: none;
  }
  .articleList-container .articleList-content{
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    .articleList{
      margin-right: 0;
    }
  }
}
</style>
